module.exports = __webpack_public_path__ + "static/img/lifestyle_30.153270fa.jpeg";